import React from "react";

export default function Support() {
    return <div className="supportBlock">
        <h1>Support</h1>
        <p>If you need any assistance please reach out to us on the contact info below</p>
        <p>+971 56 505 6375</p>
       <a href="mailto: help@thecrwd.com">help@thecrwd.com</a>
        </div>
}